import { set_pay_type } from '../confg';
import { createAction } from '@reduxjs/toolkit';

export const set_pay_type_action = createAction(set_pay_type);
